module.exports = __webpack_public_path__ + "img/home-slider1.3b409d3e.jpg";